import { Toast, } from "antd-mobile";
import api from "@/service";
const { currencyCountOfAdmin } = api;
const loginAdminMsg =
    sessionStorage.getItem("loginMsg") &&
    JSON.parse(sessionStorage.getItem("loginMsg"));
export default {
    namespace: "menu",
    state: {
        totalCount: 0,
    },
    subscriptions: {
        setup({ dispatch, history }) {
            history.listen(location => {
                if (/menu/.test(location.pathname)) {
                    console.log(222222222, "menu", location);
                    setTimeout(() => {
                        dispatch({
                            type: "app/getCurrencyCountOfAdmin",
                            payload: Array.of(loginAdminMsg.id),
                        });
                        dispatch({
                            type: 'app/getPermanentCount',
                            payload: {type:4}
                        })
                    }, 800);
                }
            });
        },
    },
    effects: {},
    reducers: {
        updateState(state, { payload }) {
            return {
                ...state,
                ...payload,
            };
        },
    },
};
